(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('stopPropagation', stopPropagation);

    function stopPropagation() {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                var eventToStop = attr.stopPropagation || 'click';
                element.on(eventToStop, function (event) {
                    if (!attr.disablePropagation || attr.disablePropagation == 'false') {
                        event.stopPropagation();
                    }
                });
            }
        }
    }

})();